(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sov-banner-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__sovBcar) return;
    root.__sovBcar = true;
    var slides = [].slice.call(root.querySelectorAll('.sov-bcar__slide'));
    var dots = [].slice.call(root.querySelectorAll('.sov-bcar__dot'));
    if (slides.length < 2) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cur = 0;
    function show(i) {
      i = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('tabindex'); }
        else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('tabindex', '-1'); }
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        var f = d.querySelector('.sov-bcar__fill');
        if (f) { f.style.animation = 'none'; void f.offsetWidth; f.style.animation = ''; }
      });
      cur = i;
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    root.querySelectorAll('.sov-bcar__fill').forEach(function (f) {
      f.addEventListener('animationend', function () { show(cur + 1); });
    });
    if (!reduce) root.classList.add('is-playing');
    function pause() { root.classList.add('is-paused'); }
    function resume() { root.classList.remove('is-paused'); }
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', resume);
    document.addEventListener('visibilitychange', function () { if (document.hidden) pause(); else resume(); });
    var x0 = null, y0 = null;
    var vp = root.querySelector('.sov-bcar__viewport');
    vp.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; pause(); }, { passive: true });
    vp.addEventListener('touchend', function (e) {
      if (x0 !== null) {
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(cur + (dx < 0 ? 1 : -1));
      }
      x0 = null; resume();
    }, { passive: true });
  }
  function boot() { document.querySelectorAll('[data-sov-bcar]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
